import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { Container, Sprite, Text } from 'pixi.js';
import { AnimationContents } from '../../AnimationContents';
import { GameLogic } from '../Logic/GameLogic';
import { LoaderButtonController } from './Loader/LoaderButtonController';
import isMobile from 'is-mobile';
import { TextInput } from '../Common/TextInput';

export interface IAfterloaderGameControllerOptions {
    isNewPlayer: boolean;
}

export class AfterloaderGameController extends AnimationBaseController {
    public $model;

    private _width;
    private _height;

    private nameInput: TextInput;
    private emailInput: TextInput;

    public constructor(
        @Inject private _options: IAfterloaderGameControllerOptions,
        @Inject private _logic: GameLogic,
    ) {
        super('AfterloaderGameController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        const childControllers = this._options.isNewPlayer ? {
            dismiss: {
                instanceName: 'Registration.btn_skip',
                controller: LoaderButtonController,
                options: {
                    onClick: () => {
                        this._logic.showCharacterScreen();
                    },
                },
            },
            partisipate: {
                instanceName: 'Registration.btn_participate',
                controller: LoaderButtonController,
                options: {
                    onClick: async () => {
                        if (this.nameInput.text !== '' &&
                            this.emailInput.text !== '' &&
                            this.emailInput.text.includes('@') &&
                            this.emailInput.text.includes('.')) {
                            this.gotoAndStopByQuery("Registration.NameBox", 1);
                            this.gotoAndStopByQuery("Registration.EmailBox", 1);

                            this._logic.saveDB(this.nameInput.text, this.emailInput.text);
                            this._logic.setIsNewPlayer(false);
                            this._logic.showCharacterScreen();

                        } else {
                            if (this.nameInput.text.length === 0) {
                                this.gotoAndPlayByQuery("Registration.NameBox", 1);
                            }
                            if (this.emailInput.text.length === 0 || !this.emailInput.text.includes('@') || !this.emailInput.text.includes('.')) {
                                this.gotoAndPlayByQuery("Registration.EmailBox", 1);
                            }
                        }
                    },
                },
            },
        } : {
            play: {
                instanceName: 'play.btn_play',
                controller: LoaderButtonController,
                options: {
                    onClick: () => {
                        this._logic.showCharacterScreen();
                    },
                },
            },
        };

        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.AFTERLOADER_SCREEN_JSON,
            libraryName: '_loading_screen',
            childControllers: {
                ...childControllers,
            },
        };
    }

    protected onInitialize(): void {
        this.gotoAndStop(this._options.isNewPlayer ? 'registration' : 'play');

        this._width = this.width;
        this._height = this.height;

        if (this._options.isNewPlayer) {
            this.generateInput();
        }
    }

    public onUpdate(frameRate: number): void {
        this.centerText();
    }

    private centerText(): void {
        if (this._options.isNewPlayer) {
            const participate = this.getDisplayObjectByQuery('Registration.btn_participate.participateText')[0] as Text;
            const participateH = this.getDisplayObjectByQuery('Registration.btn_participate.participateTextH')[0] as Text;
            const skip = this.getDisplayObjectByQuery('Registration.btn_skip.skipText')[0] as Text;
            const skipH = this.getDisplayObjectByQuery('Registration.btn_skip.skipTextH')[0] as Text;

            participate.anchor.x = 0.5;
            participateH.anchor.x = 0.5;
            participate.x = -16;
            participateH.x = -20;
            skip.anchor.x = 0.5;
            skipH.anchor.x = 0.5;
            skip.x = -16;
            skipH.x = -20;
        }
    }

    onResize(width: number, height: number, scale: number): void {
        const scaleValue = Math.min(height / scale / 1440, width / scale / 1440);
        this.scaleX = scaleValue;
        this.scaleY = scaleValue;
        const bgScale = Math.max(height/scale / 3000, width /scale / 3000);
        //@ts-ignore
        const bg = this.getDisplayObjectByQuery('bg')[0].children[0];
        console.log("bg",bg);
        bg.scale.x = bgScale/scaleValue;
        bg.scale.y = bgScale/scaleValue;
        bg.anchor.x = 0.5;
        bg.anchor.y = 0.5;
        bg.x = 0;
        
        if (this._options.isNewPlayer) {
            this.centerText();
        }
    }

    protected generateInput(): void {
        const nameBox = this.getDisplayObjectByQuery('Registration.NameBox')[0] as Container;
        const emailBox = this.getDisplayObjectByQuery('Registration.EmailBox')[0] as Container;

        this.nameInput = new TextInput('', {
            input: {
                fontSize: '26pt',
                width: `${nameBox.width - 20}px`,
                fontFamily: 'MyriadPro-Regular',
                background: 'none',
                color: '#000000',
            },
            box: null,
        });

        this.nameInput.x = 10;
        this.nameInput.y = isMobile() ? 4 : 14;

        nameBox.addChild(this.nameInput as Container);

        this.emailInput = new TextInput('', {
            input: {
                fontSize: '26pt',
                width: `${emailBox.width - 20}px`,
                background: 'none',
                color: '#000000',
            },
            box: null,
        });

        this.emailInput.x = 14;
        this.emailInput.y = isMobile() ? 4 : 14;

        emailBox.addChild(this.emailInput as Container);
    }
}
